module.exports = __webpack_public_path__ + "static/media/quiz10.c63083d5.png";